/**
 * This utility file replaces the previous use of "transactionIdForNextUpdateCellSelectionRef"
 * that was used in the old `useTableOperations`.
 *
 * Its purpose is to share a transaction ID amongst action handlers, so that multiple actions
 * can share the same Milanote transaction ID for undo/redo purposes.
 *
 * Here, we're using a hack to store the transaction ID in the Handsontable instance settings,
 * rather than using a React ref, singleton method or other way to share the transaction ID.
 *
 * This is for the following reasons:
 * 1. This will simplify code significantly.
 * 2. The need to group Milanote actions together like this might not be needed in the future,
 *     if we can rely on Handsontable's built-in undo/redo stack instead of Milanote's.
 * 3. Even if we do need to group the actions together, there might be a better way in the future.
 */
import Handsontable from 'handsontable';

export const setTransactionIdForNextUpdateCellSelection = (
    hotInstance: Handsontable.Core | null | undefined,
    transactionId: number | undefined,
) => {
    if (!hotInstance) return;

    // @ts-ignore This is a hack to store custom data in Handsontable settings
    hotInstance.getSettings().transactionIdForNextUpdateCellSelection = transactionId;
};

export const getAndClearTransactionIdForNextUpdateCellSelection = (
    hotInstance: Handsontable.Core | null | undefined,
): number | undefined => {
    if (!hotInstance) return;

    // @ts-ignore This is a hack to store custom data in Handsontable settings
    const transactionId = hotInstance.getSettings().transactionIdForNextUpdateCellSelection;

    setTransactionIdForNextUpdateCellSelection(hotInstance, undefined);

    return transactionId;
};
